export enum ROLES_CODES {
  GUEST = 'partner_guest',
  PARTNER = 'partner',
  PARTNER_MANAGER = 'partner_manager',
  SUPER_ADMIN = 'partner_super_admin',
  CEO = 'partner-ceo',
}
